// @flow

import * as React from 'react'
import { connect, type Connector } from 'react-redux'
import 'semantic-ui-css/semantic.min.css'
import { Sidebar, Segment } from 'semantic-ui-react'

import LoginForm from './login-form'
import ChangePasswordForm from './change-password-form'
import MainMenu from './systemwide/main-menu'

import CampaignGrid from './campaigns/campaigns-grid'
import PanelPage from './panels/manage-panel'
import VisitsPage from './visits/manage-visits'
import ReportsPage from './reports/reports-page'

import UsersPage from './users/manage-users'

import routerCreators from './store/router'
import { isAuthenticated, isAdmin, isViewer, getFullname, forceChangePassword } from './store/authentication'
import { goToLogout, goToUsers, goToChangePassword } from './store/router'
import SystemSidebar from './systemwide/system-sidebar'
import NotificationManager from './systemwide/notification-manager'

import type { ReduxState, Dispatch } from './store'
export type ActiveItem = '' | 'campaigns' | 'panels' | 'reports' | 'visits' | 'users' | 'change_password'

type OwnProps = {||}

type MappedProps = {|
  activeItem: ActiveItem,
  userAuthenticated: boolean,
  fullname: string,
  isAdmin: boolean,
  isViewer: boolean,
  changePasswordNeeded: boolean,
  sidebarOpened: boolean,
  reportType: string,
|}

const mapStateToProps = (state: ReduxState, ownProps: OwnProps): MappedProps => {
  let activeItem = ''
  if (/\/campaigns.*/.test(state.location.pathname)) {
    activeItem = 'campaigns'
  } else if (/\/panels.*/.test(state.location.pathname)) {
    activeItem = 'panels'
  } else if (/\/visits.*/.test(state.location.pathname)) {
    activeItem = 'visits'
  } else if (/\/reports.*/.test(state.location.pathname)) {
    activeItem = 'reports'
  } else if (/\/users.*/.test(state.location.pathname)) {
    activeItem = 'users'
  } else if (/\/change_password.*/.test(state.location.pathname)) {
    activeItem = 'change_password'
  }

  let reportType = ''
  if (state.location.payload && state.location.payload.type) {
    reportType = state.location.payload.type
  }

  return {
    activeItem: activeItem,
    userAuthenticated: isAuthenticated(state),
    fullname: getFullname(state),
    isAdmin: isAdmin(state),
    isViewer: isViewer(state),
    changePasswordNeeded: forceChangePassword(state),
    sidebarOpened: state.app.sidebarOpened,
    reportType,
  }
}

type Props = {
  dispatch: Dispatch,
} & MappedProps

class App extends React.Component<Props> {
  static defaultProps = {}

  onTabChange = (e, { value }) => {
    switch (value) {
      case 'panels':
        this.props.dispatch(routerCreators.goToPanels())
        break
      case 'visits':
        this.props.dispatch(routerCreators.goToVisits())
        break
      case 'reports/details':
      case 'reports/calendar':
      case 'reports/chart':
        let type = value.split('/')[1] || ''
        this.props.dispatch(routerCreators.goToReports(type))
        break
      default:
        this.props.dispatch(routerCreators.goToCampaigns())
    }
  }

  onLogout = () => {
    this.props.dispatch(goToLogout())
  }

  onManageUsers = () => {
    this.props.dispatch(goToUsers())
  }

  onChangePassword = () => {
    this.props.dispatch(goToChangePassword())
  }

  render() {
    if (this.props.userAuthenticated) {
      if (!this.props.changePasswordNeeded) {
        return (
          <div>
            <MainMenu
              activeItem={this.props.activeItem}
              disabled={this.props.sidebarOpened}
              isAdmin={this.props.isAdmin}
              isViewer={this.props.isViewer}
              fullname={this.props.fullname}
              onTabClick={this.onTabChange}
              onChangePassword={this.onChangePassword}
              onManageUsers={this.onManageUsers}
              onLogout={this.onLogout}
            />
            <NotificationManager />
            <Sidebar.Pushable>
              <Sidebar
                as={Segment}
                animation="overlay"
                width="very wide"
                direction="right"
                visible={this.props.sidebarOpened}
                icon="labeled"
                style={{ padding: '8ex 2ex', zIndex: 890 }}
                secondary
                vertical>
                <SystemSidebar activeItem={this.props.activeItem} />
              </Sidebar>
              <Sidebar.Pusher dimmed={this.props.sidebarOpened}>
                {this.props.activeItem === 'campaigns' && <CampaignGrid />}
                {this.props.activeItem === 'users' && <UsersPage />}
                {this.props.activeItem === 'panels' && <PanelPage />}
                {this.props.activeItem === 'visits' && <VisitsPage />}
                {this.props.activeItem === 'reports' && <ReportsPage reportType={this.props.reportType} />}
                {this.props.activeItem === 'change_password' && <ChangePasswordForm />}
              </Sidebar.Pusher>
            </Sidebar.Pushable>
          </div>
        )
      } else {
        return <ChangePasswordForm title="Cambio password richiesto" />
      }
    } else {
      return <LoginForm />
    }
  }
}

const connector: Connector<OwnProps, MappedProps> = connect(mapStateToProps, null)
export default connector(App)



// WEBPACK FOOTER //
// ./src/app.js